import { render, staticRenderFns } from "./UploadPrices.vue?vue&type=template&id=6b409d70&"
import script from "./UploadPrices.vue?vue&type=script&lang=js&"
export * from "./UploadPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports